import script from "./ForumActivity.vue?vue&type=script&setup=true&lang=js"
export * from "./ForumActivity.vue?vue&type=script&setup=true&lang=js"

import "./ForumActivity.vue?vue&type=style&index=0&id=6c813d00&lang=scss&scoped=true"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c813d00"]])

export default __exports__